<template>
  <div class="sidebar-error">
    <Heading class="sidebar-error__heading" :level="3">
      {{ sectionTitle }}
    </Heading>
    <ErrorHandler
      :title="errorTitle"
      :description="errorDescription"
      @retry="emitRetry"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Heading } from '@warrenbrasil/nebraska-web';
import { ErrorHandler } from '@/modules/common/components/ErrorHandler';

@Component({
  components: {
    ErrorHandler,
    Heading
  }
})
export default class SidebarErrorV2 extends Vue {
  @Prop({ type: String, required: true })
  readonly sectionTitle!: string;

  @Prop({ type: String, required: true })
  readonly errorTitle!: string;

  @Prop({ type: String, required: true })
  readonly errorDescription!: string;

  @Emit('retry')
  emitRetry() {}
}
</script>

<style lang="less" scoped>
.sidebar-error {
  &__heading {
    margin-bottom: @size-spacing-x300;
  }
}
</style>
